import ResponsiveImage from '@/v2/components/helpers/responsive-image'
import { CardType } from '@/v2/types/cards'
import { domAnimation, LazyMotion, m } from 'framer-motion'
import React, { memo } from 'react'

interface TabsContentSectionProps {
  tabs: CardType[]
}

const TabsContentSection: React.FC<TabsContentSectionProps> = props => {
  const { tabs } = props

  return (
    <LazyMotion features={domAnimation}>
      <div className='!grid lg-mn:grid-cols-3 md-mn:grid-cols-2 grid-cols-1 lg-mn:gap-[44px] gap-[20px] mt-[24px]'>
        {tabs.map(tab => {
          return (
            <m.article
              key={tab.id}
              className='text-center flex items-center flex-col lg-mn:p-[25px] p-[20px] [&>h3]:text-tertiary-foreground
              [&>h3]:font-[600] md-mn:[&>h3]:text-[20px] [&>h3]:leading-[28px] [&>h3]:text-[18px] [&>h3]:mb-[8px] [&>h3]:mt-[12px] xl:[&>h3]:mb-[12px] xl:[&>h3]:mt-[16px]'
            >
              <div>
                <ResponsiveImage
                  src={tab.image.src}
                  alt={tab.image.alt}
                  className='xl-min:w-[465px] xl-min:h-[264px] w-[328px] h-[188px]'
                />
              </div>
              <h3>{tab.title}</h3>
              <p className='text-paragraph leading-[24px] font-[400] tex-[16px]'>{tab.description}</p>
            </m.article>
          )
        })}
      </div>
    </LazyMotion>
  )
}

export default memo(TabsContentSection)
